/* eslint-disable prettier/prettier, linebreak-style, indent */
/* global jQuery */
class RecruitmentCardsSlider {
  constructor() {
    this.selectors = {
      slider: '.js-rec-cards',
    };

    this.classes = {};

    this.getDOM();

    window.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  getDOM() {
    this.DOM = {
      sliders: document.querySelectorAll(this.selectors.slider),
    };
  }

  init() {
    if (this.DOM.sliders.length) {
      this.DOM.sliders.forEach((slider) => {
        const items = slider.getAttribute('data-items') || 2;
        const showItems = items > 1 ? items - 1 : 1;

        jQuery(slider).slick({
          slidesToShow: showItems,
          arrows: false,
          autoplay: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: showItems > 1 ? 2 : 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      });
    }
  }
}

export default new RecruitmentCardsSlider();
